import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 41;

export const migration_40_41:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {componentDesc} = boxSnapshot;

                        componentDesc._baseProperties = migratePropsSnapshot(componentDesc._baseProperties);
                        componentDesc._properties = migratePropsSnapshot(componentDesc._properties);
                        componentDesc._layoutProperties = migratePropsSnapshot(componentDesc._layoutProperties);
                        componentDesc._baseEventProps = migratePropsSnapshot(componentDesc._baseEventProps);
                        componentDesc._eventProps = migratePropsSnapshot(componentDesc._eventProps);
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function migratePropsSnapshot(propsSnapshot:any):any
{
    const newPropsSnapshot = {};

    Object.values(propsSnapshot).forEach(
        (propSnapshot:any) => newPropsSnapshot[propSnapshot.name] = propSnapshot
    );

    return newPropsSnapshot;
}
